import { WechatOutlined } from "@ant-design/icons";
import { Button, Divider, Form, Input, Popover, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import './form-style.css';

export default function Forms() {

  const handleFormSubmit = (values: any) => {
    axios({
      method: "POST",
      url: "https://formbold.com/s/ozmm8",
      data: values,
    })
      .then((r) => {
        message.success("Message sent")
      })
      .catch((r) => {
        message.error("Error sending message")
        console.log("error: ", r);
      });

  };

  const content = (
    <div style={{ width: "300px" }}>
      <Form layout="vertical" onFinish={handleFormSubmit}>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: 'Please enter your email' }]}
        >
          <Input placeholder="Subject" />
        </Form.Item>
        <Form.Item
          label="Subject"
          name="subject"
          rules={[{ required: true, message: 'Please enter a subject' }]}
        >
          <Input placeholder="Subject" />
        </Form.Item>
        <Form.Item
          name="message"
          rules={[{ required: true, message: 'Please enter a message' }]}
        >
          <TextArea placeholder="Message" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Send
          </Button>
        </Form.Item>
      </Form>
    </div>
  );

  return (
    <Popover
      className="black-background"
      content={content}
      title={<Divider orientation="left">Contact Us</Divider>}
      trigger="click"
      placement="bottom"
    >
      <Button
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#06142A',
          color: 'white',
        }}
        size="large"
        icon={<WechatOutlined style={{ fontSize: '25px' }} />}
      />
    </Popover>

  );


}